import React from 'react';
import styles from './Contact.module.css';

const Contact = () => {
  // Update with actual information
  const phoneNumber = "804-343-1322";
  // Update with actual email address if available
  const email = "info@elitecleaners.com"; // Placeholder email

  return (
    <section id="contact" className={styles.contact}>
      <div className={styles.container}>
        <h2 className={styles.contactTitle}>Call Us</h2>
        <div className={styles.contactContent}>
          <div className={styles.contactInfo}>
            <p>Have a question? Give us a call!</p>
            <div className={styles.phoneInfo}>
              <p>
                <a href={`tel:${phoneNumber.replace(/[^0-9]/g, '')}`} className={styles.phoneButton}>{phoneNumber}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
